exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#gallery-page table {\n  margin-top: 40px; }\n  #gallery-page table thead {\n    text-align: center; }\n  #gallery-page table tbody img.thumb {\n    max-width: 192px;\n    max-height: 108px; }\n  #gallery-page table tbody tr {\n    height: 110px; }\n    #gallery-page table tbody tr td.thumb-col {\n      width: 200px; }\n    #gallery-page table tbody tr td p.description {\n      font-size: 13px; }\n\n#gallery-page .thumb {\n  height: 110px; }\n\n#gallery-page .media-body {\n  font-size: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/gallery/gallery.component.scss
// module id = ../../../../../src/app/gallery/gallery.component.scss
// module chunks = main